import React from 'react';
import { IconCloseSquircle, rem } from 'design-system';
import { StyleSheet, TouchableOpacity, View, } from 'react-native';
import { Avatar } from 'design-system/avatar';
import useColors from 'hooks/useColors';
export const CircleContactClosable = ({ onPress, ...props }) => {
    const colors = useColors();
    return (<TouchableOpacity style={styles.container} onPress={onPress}>
      <Avatar {...props} color={colors.background.brandLight} fontColor={colors.text.textOnBrand} borderWidth={1} size={44}/>
      <View style={styles.badgeStyle}>
        <IconCloseSquircle width={24} height={24} crossColor={colors.elements.white}/>
      </View>
    </TouchableOpacity>);
};
const styles = StyleSheet.create({
    container: {
        marginTop: rem(4),
        marginRight: rem(16),
    },
    badgeStyle: {
        alignItems: 'center',
        justifyContent: 'center',
        width: rem(18),
        height: rem(18),
        position: 'absolute',
        top: rem(-4),
        right: rem(-2),
    },
});
